import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALGROUPITEM_LOAD_BY_ID,
    ACTION_TRIALGROUPITEM_LOAD_BY_TRIALGROUP_ID,
    ACTION_TRIALGROUPITEM_CREATE,
    ACTION_TRIALGROUPITEM_SAVE,

    ITrialGroupItemsLoadByTrialGroupIdAction,
    ITrialGroupItemLoadFailureAction,
    ITrialGroupItemLoadSuccessAction,
    ITrialGroupItemLoadByIdAction,

    ITrialGroupItemSaveSuccessAction,
    ITrialGroupItemSaveFailureAction,
    ITrialGroupItemSaveAction,

    ITrialGroupItemCreateAction,
    ITrialGroupItemCreateSuccessAction,
    ITrialGroupItemCreateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveFailure,
    SaveSuccess,

    CreateSuccess,
    CreateFailure,
} from "../actions/trialGroupItem";
import { trialGroupItemsApi } from "../services/trialGroupItems";


export const
    getTrialGroupItemByIdEpic = (action$): Observable<ITrialGroupItemLoadSuccessAction | ITrialGroupItemLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPITEM_LOAD_BY_ID)
            .mergeMap((action: ITrialGroupItemLoadByIdAction) => {
                return trialGroupItemsApi
                    .getTrialGroupItemById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialGroupItem, undefined, undefined, undefined, undefined, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialGroupItemsByTrialGroupIdEpic = (action$): Observable<ITrialGroupItemLoadSuccessAction | ITrialGroupItemLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPITEM_LOAD_BY_TRIALGROUP_ID)
            .mergeMap((action: ITrialGroupItemsLoadByTrialGroupIdAction) => {
                return trialGroupItemsApi
                    .getTrialGroupItemsByTrialGroupId(action.trialGroupId)
                    .map(response =>
                        LoadSuccess(response.trialGroupItems, response.trialGroupItemCategories, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialGroupItemEpic = (action$): Observable<ITrialGroupItemSaveSuccessAction | ITrialGroupItemSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPITEM_SAVE)
            .mergeMap((action: ITrialGroupItemSaveAction) => {
                return trialGroupItemsApi
                    .setTrialGroupItem(action.formData, action.collectionFormData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialGroupItem, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialGroupItemEpic = (action$): Observable<ITrialGroupItemCreateSuccessAction | ITrialGroupItemCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPITEM_CREATE)
            .mergeMap((action: ITrialGroupItemCreateAction) => {
                return trialGroupItemsApi
                    .createTrialGroupItem(action.trialGroupId)
                    .map(response =>
                        CreateSuccess(response.trialGroupItem, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    }
